var rich_content_viewer_default = {
  "fontElementMap": "NX1B6",
  "wrapper": "mPaw7",
  "pluginContainerMobile": "_82Ppm",
  "viewer": "MMGjR",
  "android": "gMwcG",
  "rootedTraversedContent": "aadF-",
  "atomic": "_3JSw-",
  "toolbar": "GJJZZ",
  "block": "mdr0d"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
